import React from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { adminService } from '../services/api';

interface AdminRouteProps {
  children: React.ReactNode;
}

interface UserData {
  is_admin: boolean;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { data, isLoading } = useQuery<UserData>({
    queryKey: ['user_id'],
    queryFn: async () => {
      const response = await adminService.check();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!data?.is_admin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute; 